<span [style.backgroundColor]="status?.color" class="status-colored">{{ status?.humanReadableName }}</span>
